export default __webpack_public_path__ + "static/media/GHSI Non Audit Services Policy.dd33581a.pdf";